import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 volume', '5 bonusuri', '240 de pagini', 'Clasele 0–VIII'];
const reassurances = ['Descărcare digitală imediată', 'Fișiere PDF printabile', 'Garanție de satisfacție 7 zile'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15fghwkon130x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbadk20ehvw3" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2yb8knjw960">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t252je5179l8">
          Orele tale de tehnologie pot fi <em className="text-red-700" data-id="element-118" data-mp="223d0tw7jsafb">gata chiar de azi.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221jpi3lzp20z">
          În loc să cauți fișe, să faci fiecare proiect de la zero și să-ți petreci duminicile
          planificând, ai un pachet de tehnologie organizat pentru tot anul școlar. Mai mult timp pentru
          ce contează cu adevărat:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x38ytrhg9u4b">
          Elevii tăi. Orele tale. Viața ta în afara școlii.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120inh4x0m1r3">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b2rvno4t9j1b">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1gs9pfa2daq">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fwmeyqgi7vzv">Plată unică – fără abonament.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1kvfo66ord0u8">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pth96x5qva8c" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1tu17i4220jw2">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qtvuq5r6uqcj">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3lvkpk8bu940n" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}